(function (w) {
  'use strict';
  if (w.MaxpromoCustomerAPI) return;

  var CONFIG = {
    clientId: '9bbe4427-9504-42c6-a5fa-7745c83c12c7',
    shopDomain: 'fqnc1v-je.myshopify.com',
    origin: 'https://fqnc1v-je.myshopify.com',
    redirectUri: 'https://fqnc1v-je.myshopify.com/pages/maxpromo-account-callback',
    logoutUri: 'https://fqnc1v-je.myshopify.com/',
    scope: 'openid email customer-account-api:full'
  };

  var KEYS = {
    tokens: 'mps_customer_api_tokens_v1',
    state: 'mps_customer_api_state_v1',
    nonce: 'mps_customer_api_nonce_v1',
    verifier: 'mps_customer_api_verifier_v1',
    returnTo: 'mps_customer_api_return_v1',
    logoutIdToken: 'mps_customer_api_logout_id_token_v2'
  };

  function storageGet(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function storageSet(key, value) {
    try { sessionStorage.setItem(key, value); return true; } catch (e) { return false; }
  }
  function storageRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }
  function randomBytes(length) {
    var bytes = new Uint8Array(length || 32);
    crypto.getRandomValues(bytes);
    return bytes;
  }
  function base64Url(bytes) {
    var binary = '';
    for (var i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }
  async function codeChallenge(verifier) {
    var digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
    return base64Url(new Uint8Array(digest));
  }
  function decodeJwtPayload(token) {
    try {
      var part = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      while (part.length % 4) part += '=';
      var binary = atob(part);
      var bytes = new Uint8Array(binary.length);
      for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) { return null; }
  }
  function clearFlow() {
    storageRemove(KEYS.state);
    storageRemove(KEYS.nonce);
    storageRemove(KEYS.verifier);
  }
  function getTokens() {
    var raw = storageGet(KEYS.tokens);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  function setTokens(payload) {
    var current = getTokens() || {};
    var next = {
      access_token: payload.access_token || current.access_token || '',
      refresh_token: payload.refresh_token || current.refresh_token || '',
      id_token: payload.id_token || current.id_token || '',
      expires_at: payload.expires_in ? Date.now() + (Number(payload.expires_in) * 1000) - 30000 : (current.expires_at || 0)
    };
    storageSet(KEYS.tokens, JSON.stringify(next));
    return next;
  }
  function clearTokens() {
    var current = getTokens();
    if (current && current.id_token) storageSet(KEYS.logoutIdToken, current.id_token);
    storageRemove(KEYS.tokens);
  }
  function hasSession() {
    var t = getTokens();
    return !!(t && ((t.access_token && t.expires_at > Date.now()) || t.refresh_token));
  }
  function isPreviewRuntime() {
    var params = new URLSearchParams(location.search);
    var shopify = w.Shopify || {};
    var theme = shopify.theme || {};
    return location.hostname.indexOf('shopifypreview.com') !== -1 ||
      params.has('preview_theme_id') ||
      !!shopify.designMode ||
      (theme.role && String(theme.role).toLowerCase() !== 'main');
  }
  function canUseCustomerAuth() {
    return location.hostname === CONFIG.shopDomain;
  }
  async function discoverAuth() {
    var res = await fetch(CONFIG.origin + '/.well-known/openid-configuration', { credentials: 'omit', cache: 'no-store' });
    if (!res.ok) throw new Error('Configuration de connexion Shopify indisponible.');
    return res.json();
  }
  async function discoverApi() {
    var res = await fetch(CONFIG.origin + '/.well-known/customer-account-api', { credentials: 'omit', cache: 'no-store' });
    if (!res.ok) throw new Error('API de compte client Shopify indisponible.');
    var data = await res.json();
    if (!data.graphql_api) throw new Error('Point GraphQL du compte client introuvable.');
    return data.graphql_api;
  }
  function safeReturnTo(value) {
    try {
      var u = new URL(value || '/', CONFIG.origin);
      if (u.origin !== CONFIG.origin || u.pathname === '/pages/maxpromo-account-callback') return '/';
      return u.pathname + u.search + u.hash;
    } catch (e) { return '/'; }
  }
  async function login(returnTo, options) {
    options = options || {};
    if (!canUseCustomerAuth()) return false;
    if (!w.crypto || !w.crypto.subtle) throw new Error('Ce navigateur ne prend pas en charge la connexion sécurisée.');

    var auth = await discoverAuth();
    var verifier = base64Url(randomBytes(32));
    var challenge = await codeChallenge(verifier);
    var state = base64Url(randomBytes(24));
    var nonce = base64Url(randomBytes(24));

    storageSet(KEYS.verifier, verifier);
    storageSet(KEYS.state, state);
    storageSet(KEYS.nonce, nonce);
    storageSet(KEYS.returnTo, safeReturnTo(returnTo || location.href));

    var url = new URL(auth.authorization_endpoint);
    url.searchParams.set('scope', CONFIG.scope);
    url.searchParams.set('client_id', CONFIG.clientId);
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('redirect_uri', CONFIG.redirectUri);
    url.searchParams.set('state', state);
    url.searchParams.set('nonce', nonce);
    url.searchParams.set('code_challenge', challenge);
    url.searchParams.set('code_challenge_method', 'S256');
    url.searchParams.set('locale', 'fr-FR');
    url.searchParams.set('region_country', 'FR');
    var loginHint = String(options.email || options.loginHint || '').trim();
    if (loginHint) url.searchParams.set('login_hint', loginHint);
    if (options.silent) url.searchParams.set('prompt', 'none');
    location.assign(url.toString());
    return true;
  }
  async function exchangeCode(code) {
    var verifier = storageGet(KEYS.verifier);
    if (!verifier) throw new Error('Session de connexion expirée. Recommencez la connexion.');
    var auth = await discoverAuth();
    var body = new URLSearchParams();
    body.set('grant_type', 'authorization_code');
    body.set('client_id', CONFIG.clientId);
    body.set('redirect_uri', CONFIG.redirectUri);
    body.set('code', code);
    body.set('code_verifier', verifier);

    var res = await fetch(auth.token_endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: body
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || !data.access_token) throw new Error(data.error_description || data.error || 'Impossible de terminer la connexion Shopify.');

    var expectedNonce = storageGet(KEYS.nonce);
    if (expectedNonce && data.id_token) {
      var payload = decodeJwtPayload(data.id_token);
      if (!payload || payload.nonce !== expectedNonce) throw new Error('Vérification de sécurité de la connexion impossible.');
    }
    return setTokens(data);
  }
  async function refreshAccessToken() {
    var current = getTokens();
    if (!current || !current.refresh_token) return null;
    var auth = await discoverAuth();
    var body = new URLSearchParams();
    body.set('grant_type', 'refresh_token');
    body.set('client_id', CONFIG.clientId);
    body.set('refresh_token', current.refresh_token);
    var res = await fetch(auth.token_endpoint, {
      method: 'POST',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      body: body
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || !data.access_token) {
      clearTokens();
      return null;
    }
    return setTokens(data);
  }
  async function ensureAccessToken() {
    var t = getTokens();
    if (t && t.access_token && t.expires_at > Date.now()) return t.access_token;
    t = await refreshAccessToken();
    return t && t.access_token ? t.access_token : null;
  }
  async function graphql(query, variables, retried) {
    var token = await ensureAccessToken();
    if (!token) throw new Error('Votre session est en cours de synchronisation.');
    var endpoint = await discoverApi();
    var res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': token },
      body: JSON.stringify({ query: query, variables: variables || {} })
    });
    if (res.status === 401 && !retried) {
      var refreshed = await refreshAccessToken();
      if (refreshed) return graphql(query, variables, true);
    }
    var json = await res.json().catch(function () { return {}; });
    if (!res.ok) throw new Error('Shopify a refusé la requête du compte client.');
    if (json.errors && json.errors.length) throw new Error(json.errors[0].message || 'Erreur du compte client Shopify.');
    return json.data;
  }

  var CUSTOMER_QUERY = 'query MaxpromoCustomerAccount { customer { id firstName lastName displayName imageUrl emailAddress { emailAddress } phoneNumber { phoneNumber } defaultAddress { id name firstName lastName address1 address2 city province zip country phoneNumber territoryCode zoneCode formatted(withName: true, withCompany: true) } addresses(first: 20) { nodes { id name firstName lastName address1 address2 city province zip country phoneNumber territoryCode zoneCode } } orders(first: 20, reverse: true) { nodes { id name confirmationNumber number createdAt processedAt updatedAt cancelledAt cancelReason email phone note financialStatus fulfillmentStatus statusPageUrl repairInboundTracking: metafield(namespace: "maxpromo", key: "repair_inbound_tracking") { value } repairOutboundTracking: metafield(namespace: "maxpromo", key: "repair_outbound_tracking") { value } subtotal { amount currencyCode } totalShipping { amount currencyCode } totalTax { amount currencyCode } totalPrice { amount currencyCode } totalRefunded { amount currencyCode } paymentInformation { paymentStatus totalPaidAmount { amount currencyCode } totalOutstandingAmount { amount currencyCode } } transactions { id status kind type createdAt processedAt transactionAmount { shopMoney { amount currencyCode } presentmentMoney { amount currencyCode } } paymentDetails { __typename ... on CardPaymentDetails { cardBrand last4 } } } shippingLine { title } shippingAddress { firstName lastName address1 address2 city zoneCode zip country phoneNumber } billingAddress { firstName lastName address1 address2 city zoneCode zip country phoneNumber } discountApplications(first: 10) { nodes { __typename ... on DiscountCodeApplication { code } ... on AutomaticDiscountApplication { title } ... on ManualDiscountApplication { title } } } lineItems(first: 50) { nodes { title quantity variantTitle customAttributes { key value } image { url altText } price { amount currencyCode } totalPrice { amount currencyCode } } } } } } }';
  var UPDATE_NAME = 'mutation MaxpromoCustomerUpdate($input: CustomerUpdateInput!) { customerUpdate(input: $input) { customer { id firstName lastName displayName } userErrors { field message } } }';
  var ADDRESS_CREATE = 'mutation MaxpromoCustomerAddressCreate($address: CustomerAddressInput!, $defaultAddress: Boolean) { customerAddressCreate(address: $address, defaultAddress: $defaultAddress) { customerAddress { id name address1 address2 city province zip country phoneNumber territoryCode zoneCode } userErrors { field message } } }';
  var ADDRESS_UPDATE = 'mutation MaxpromoCustomerAddressUpdate($addressId: ID!, $address: CustomerAddressInput, $defaultAddress: Boolean) { customerAddressUpdate(addressId: $addressId, address: $address, defaultAddress: $defaultAddress) { customerAddress { id name address1 address2 city province zip country phoneNumber territoryCode zoneCode } userErrors { field message } } }';
  var ADDRESS_DELETE = 'mutation MaxpromoCustomerAddressDelete($addressId: ID!) { customerAddressDelete(addressId: $addressId) { deletedAddressId userErrors { field message } } }';

  function mutationResult(payload, key) {
    var node = payload && payload[key];
    if (!node) throw new Error('Réponse Shopify incomplète.');
    if (node.userErrors && node.userErrors.length) throw new Error(node.userErrors[0].message || 'Modification impossible.');
    return node;
  }
  async function getCustomer() {
    var data = await graphql(CUSTOMER_QUERY);
    if (!data || !data.customer) throw new Error('Compte client introuvable.');
    return data.customer;
  }
  async function updateName(firstName, lastName) {
    var data = await graphql(UPDATE_NAME, { input: { firstName: firstName || '', lastName: lastName || '' } });
    return mutationResult(data, 'customerUpdate').customer;
  }
  async function createAddress(address, defaultAddress) {
    var data = await graphql(ADDRESS_CREATE, { address: address, defaultAddress: !!defaultAddress });
    return mutationResult(data, 'customerAddressCreate').customerAddress;
  }
  async function updateAddress(addressId, address, defaultAddress) {
    var data = await graphql(ADDRESS_UPDATE, { addressId: addressId, address: address, defaultAddress: !!defaultAddress });
    return mutationResult(data, 'customerAddressUpdate').customerAddress;
  }
  async function deleteAddress(addressId) {
    var data = await graphql(ADDRESS_DELETE, { addressId: addressId });
    return mutationResult(data, 'customerAddressDelete').deletedAddressId;
  }
  async function sendWelcomeEmail() {
    var token = await ensureAccessToken();
    if (!token) throw new Error('Votre session est en cours de synchronisation.');
    var res = await fetch('https://reprise-secure-production.up.railway.app/customer/welcome', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': token },
      body: '{}'
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok || !data.success) throw new Error(data.error || 'Impossible d\'envoyer le mail de bienvenue.');
    return true;
  }
  async function logout() {
    var t = getTokens();
    var idToken = (t && t.id_token) || storageGet(KEYS.logoutIdToken) || '';
    clearTokens();
    clearFlow();
    storageRemove(KEYS.returnTo);
    storageRemove('mxp_force_logout_gateway_v3');
    storageRemove('mps_force_storefront_logout_v2');
    w.dispatchEvent(new CustomEvent('mps:customer-logout'));
    var fallback = w.setTimeout(function () { location.replace(CONFIG.logoutUri); }, 1800);
    var auth = null;
    try { auth = await discoverAuth(); } catch (e) {}
    if (idToken && auth && auth.end_session_endpoint) {
      w.clearTimeout(fallback);
      var url = new URL(auth.end_session_endpoint);
      url.searchParams.set('id_token_hint', idToken);
      url.searchParams.set('post_logout_redirect_uri', CONFIG.logoutUri);
      storageRemove(KEYS.logoutIdToken);
      location.replace(url.toString());
      return;
    }
    w.clearTimeout(fallback);
    storageRemove(KEYS.logoutIdToken);
    location.replace(CONFIG.logoutUri);
  }
  async function handleCallback() {
    var params = new URLSearchParams(location.search);
    var error = params.get('error');
    if (error) {
      clearFlow();
      throw new Error(params.get('error_description') || error);
    }
    var code = params.get('code');
    var returnedState = params.get('state');
    if (!code) throw new Error('Code de connexion Shopify manquant.');
    var expectedState = storageGet(KEYS.state);
    if (!expectedState || returnedState !== expectedState) throw new Error('État de sécurité invalide. Recommencez la connexion.');
    await exchangeCode(code);
    clearFlow();
    var returnTo = safeReturnTo(storageGet(KEYS.returnTo) || '/?mps_account=1');
    storageRemove(KEYS.returnTo);
    if (returnTo.indexOf('mps_account=1') === -1) {
      var u = new URL(returnTo, CONFIG.origin);
      u.searchParams.set('mps_account', '1');
      returnTo = u.pathname + u.search + u.hash;
    }
    w.dispatchEvent(new CustomEvent('mps:customer-authenticated'));
    location.replace(returnTo);
    return true;
  }

  w.MaxpromoCustomerAPI = {
    config: CONFIG,
    canUseCustomerAuth: canUseCustomerAuth,
    hasSession: hasSession,
    login: login,
    handleCallback: handleCallback,
    getCustomer: getCustomer,
    updateName: updateName,
    createAddress: createAddress,
    updateAddress: updateAddress,
    deleteAddress: deleteAddress,
    sendWelcomeEmail: sendWelcomeEmail,
    logout: logout,
    clearSession: clearTokens
  };
})(window);


/* MXP_PROFILE_PREMIUM_MOCKUP_V1 */
(function(){
  'use strict';

  var STYLE_ID='mxp-profile-premium-mockup-v1';

  function addStyles(){
    if(document.getElementById(STYLE_ID))return;
    var style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent=`
[data-mps-api-panel="profile"].mxp-profile-premium-v1{padding:0 4px 28px!important}
[data-mps-api-panel="profile"].mxp-profile-premium-v1>.mxp-page-head{margin:0 0 18px!important;padding-right:120px!important}
[data-mps-api-panel="profile"].mxp-profile-premium-v1>.mxp-page-head h1{font-size:36px!important;line-height:1!important;letter-spacing:-.045em!important;color:#111827!important}
[data-mps-api-panel="profile"].mxp-profile-premium-v1>.mxp-page-head p{margin-top:8px!important;color:#737f91!important;font-size:13px!important;line-height:1.45!important}
[data-mps-api-panel="profile"] .mps-api-profile-card.mxp-profile-premium-summary{position:relative!important;display:grid!important;grid-template-columns:76px minmax(0,1fr) auto!important;align-items:center!important;gap:18px!important;min-height:142px!important;margin:0 0 18px!important;padding:21px 27px!important;overflow:hidden!important;border:1px solid #efe1a8!important;border-radius:20px!important;background:linear-gradient(108deg,#fff 0%,#fffdf8 56%,#fff6d4 100%)!important;box-shadow:0 10px 26px rgba(15,23,42,.035)!important}
[data-mps-api-panel="profile"] .mps-api-profile-card.mxp-profile-premium-summary:after{content:"";position:absolute!important;right:27%;top:-50px!important;width:92px!important;height:240px!important;transform:rotate(29deg)!important;background:rgba(255,196,0,.065)!important;pointer-events:none!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-avatar{position:relative!important;z-index:1!important;width:74px!important;height:74px!important;border-radius:50%!important;background:#fff4c9!important;color:#f2b500!important;font-size:20px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-identity{position:relative!important;z-index:1!important;min-width:0!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-identity>span{color:#f1b400!important;font-size:9px!important;font-weight:950!important;letter-spacing:.05em!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-identity>strong{display:block!important;margin-top:7px!important;color:#101827!important;font-size:20px!important;line-height:1.15!important;letter-spacing:-.025em!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-identity>small{display:flex!important;align-items:center!important;gap:8px!important;margin-top:9px!important;color:#738096!important;font-size:11px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-identity>small:before{content:"✉";font-size:14px!important;color:#657287!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-note{position:relative!important;z-index:1!important;display:flex!important;align-items:center!important;gap:14px!important;padding-left:28px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-note__icon{display:grid!important;place-items:center!important;width:52px!important;height:52px!important;border-radius:50%!important;background:rgba(255,196,0,.13)!important;color:#f2b400!important;font-size:22px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-note p{margin:0!important;color:#758196!important;font-size:11px!important;line-height:1.45!important;font-weight:650!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-note b{display:block!important;width:46px!important;height:4px!important;margin-top:9px!important;border-radius:99px!important;background:#ffc400!important}
[data-mps-api-panel="profile"] form.mps-api-profile-form.mxp-profile-premium-form{display:block!important;padding:24px 26px 22px!important;border:1px solid #e2e7ed!important;border-radius:20px!important;background:#fff!important;box-shadow:0 12px 34px rgba(15,23,42,.04)!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-form-head{display:flex!important;align-items:center!important;gap:14px!important;margin-bottom:21px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-form-head>i{display:grid!important;place-items:center!important;flex:0 0 44px!important;width:44px!important;height:44px!important;border-radius:13px!important;background:#fff4ca!important;color:#efb500!important;font-style:normal!important;font-size:21px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-form-head strong{display:block!important;color:#101827!important;font-size:17px!important;letter-spacing:-.02em!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-form-head p{margin:4px 0 0!important;color:#758196!important;font-size:11px!important;line-height:1.45!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-grid{display:grid!important;grid-template-columns:1fr 1fr!important;gap:14px 12px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-grid label{display:block!important;color:#465266!important;font-size:10px!important;font-weight:850!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-grid label.wide{grid-column:1/-1!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-label{display:block!important;margin-bottom:7px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-label em{color:#ef4444!important;font-style:normal!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input{display:flex!important;align-items:center!important;min-height:50px!important;border:1px solid #dfe4ea!important;border-radius:11px!important;background:#fff!important;transition:border-color .16s,box-shadow .16s!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input:focus-within{border-color:#e3b71a!important;box-shadow:0 0 0 4px rgba(255,196,0,.12)!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input.is-readonly{background:#fafbfc!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input>i{display:grid!important;place-items:center!important;flex:0 0 38px!important;color:#5e6a7d!important;font-style:normal!important;font-size:16px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input>input{width:100%!important;min-height:48px!important;padding:0 14px 0 0!important;border:0!important;border-radius:11px!important;background:transparent!important;box-shadow:none!important;color:#101827!important;font-size:12px!important;font-weight:750!important;outline:0!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-input>input[readonly]{background:transparent!important;color:#414c5e!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-actions{display:flex!important;align-items:center!important;gap:10px!important;flex-wrap:wrap!important;margin-top:17px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-actions button{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:9px!important;min-height:46px!important;padding:0 22px!important;border-radius:11px!important;font:inherit!important;font-size:10px!important;font-weight:900!important;cursor:pointer!important;transition:.16s!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save{min-width:250px!important;border:1px solid #ffc400!important;background:#ffc400!important;color:#111827!important;box-shadow:0 6px 15px rgba(255,196,0,.18)!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save:not(:disabled):hover{transform:translateY(-1px)!important;box-shadow:0 9px 20px rgba(255,196,0,.22)!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-cancel{border:1px solid #dfe4ea!important;background:#fff!important;color:#202938!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-actions button:disabled{cursor:default!important;opacity:.72!important;box-shadow:none!important;transform:none!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save:disabled{border-color:#e4e8ed!important;background:#f2f4f6!important;color:#98a1ae!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save.is-saving{opacity:1!important;border-color:#ffe16b!important;background:#fff3b0!important;color:#665100!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save.is-saving:before{content:"";width:12px!important;height:12px!important;border:2px solid currentColor!important;border-right-color:transparent!important;border-radius:50%!important;animation:mxpProfileSpin .7s linear infinite!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-save.is-success{opacity:1!important;border-color:#cfe8d4!important;background:#edf8ef!important;color:#2f6b3a!important;box-shadow:0 5px 14px rgba(47,107,58,.08)!important}
[data-mps-api-panel="profile"] [data-mps-api-profile-message]{display:inline-flex!important;align-items:center!important;min-height:30px!important;padding:0 10px!important;border-radius:999px!important;color:#657286!important;background:transparent!important;font-size:10px!important;font-weight:850!important;opacity:1!important;transition:opacity .22s ease,transform .22s ease,background .22s ease!important}
[data-mps-api-panel="profile"] [data-mps-api-profile-message].is-success{color:#2f6b3a!important;background:#edf8ef!important}
[data-mps-api-panel="profile"] [data-mps-api-profile-message].is-error{color:#a33b33!important;background:#fff0ee!important}
[data-mps-api-panel="profile"] [data-mps-api-profile-message].is-fading{opacity:0!important;transform:translateY(-2px)!important}
@keyframes mxpProfileSpin{to{transform:rotate(360deg)}}
[data-mps-api-panel="profile"] .mxp-profile-premium-hint{display:flex!important;align-items:center!important;gap:8px!important;margin-top:12px!important;color:#7b8798!important;font-size:10px!important}
[data-mps-api-panel="profile"] .mxp-profile-premium-hint i{font-style:normal!important;font-size:14px!important;color:#617087!important}
.mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])){--orange:#ffc400!important;--orange-dark:#e5b200!important;--orange-soft:#fff6d8!important}
.mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])) [data-mps-api-nav="profile"].is-active{background:#ffc400!important;color:#111827!important;box-shadow:0 7px 18px rgba(255,196,0,.22)!important}
.mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])) .mps-api-portal__close{display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;width:auto!important;height:42px!important;padding:0 18px!important;border-radius:999px!important;border-color:#eadb9f!important;background:#fffdf7!important;color:#111827!important;font-size:16px!important}
.mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])) .mps-api-portal__close b{display:block!important;font-size:10px!important}
@media(max-width:900px){
  [data-mps-api-panel="profile"] .mps-api-profile-card.mxp-profile-premium-summary{grid-template-columns:64px 1fr!important}
  [data-mps-api-panel="profile"] .mxp-profile-premium-note{display:none!important}
  [data-mps-api-panel="profile"] .mxp-profile-premium-grid{grid-template-columns:1fr!important}
  [data-mps-api-panel="profile"] .mxp-profile-premium-grid label.wide{grid-column:auto!important}
}
@media(max-width:620px){
  [data-mps-api-panel="profile"].mxp-profile-premium-v1>.mxp-page-head{padding-right:50px!important}
  [data-mps-api-panel="profile"].mxp-profile-premium-v1>.mxp-page-head h1{font-size:27px!important}
  [data-mps-api-panel="profile"] .mps-api-profile-card.mxp-profile-premium-summary{padding:17px!important;border-radius:16px!important}
  [data-mps-api-panel="profile"] form.mps-api-profile-form.mxp-profile-premium-form{padding:18px!important;border-radius:16px!important}
  [data-mps-api-panel="profile"] .mxp-profile-premium-actions{display:grid!important;grid-template-columns:1fr!important}
  [data-mps-api-panel="profile"] .mxp-profile-premium-actions button{width:100%!important;min-width:0!important}
  .mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])) .mps-api-portal__close{width:38px!important;height:38px!important;padding:0!important}
  .mps-api-portal:has([data-mps-api-panel="profile"]:not([hidden])) .mps-api-portal__close b{display:none!important}
}
`;
    document.head.appendChild(style);
  }

  function enhanceProfile(){
    var section=document.querySelector('[data-mps-api-panel="profile"]');
    if(!section || section.dataset.mxpPremiumProfile==='1')return;
    section.dataset.mxpPremiumProfile='1';
    section.classList.add('mxp-profile-premium-v1');

    var head=section.querySelector('.mxp-page-head');
    if(head){
      var p=head.querySelector('p');
      if(p)p.textContent='Modifiez votre prénom et votre nom. L’e-mail et le téléphone sont affichés à titre informatif.';
    }

    var card=section.querySelector('.mps-api-profile-card');
    if(card){
      card.classList.add('mxp-profile-premium-summary');
      var avatar=card.querySelector('[data-mps-api-profile-avatar]');
      if(avatar)avatar.classList.add('mxp-profile-premium-avatar');
      var identity=avatar&&avatar.nextElementSibling;
      if(identity)identity.classList.add('mxp-profile-premium-identity');
      if(!card.querySelector('.mxp-profile-premium-note')){
        var note=document.createElement('div');
        note.className='mxp-profile-premium-note';
        note.innerHTML='<span class="mxp-profile-premium-note__icon">♙</span><div><p>Vos informations nous permettent<br>de mieux vous accompagner.</p><b></b></div>';
        card.appendChild(note);
      }
    }

    var form=section.querySelector('[data-mps-api-profile-form]');
    if(!form)return;
    form.classList.add('mxp-profile-premium-form');

    var first=form.elements.firstName;
    var last=form.elements.lastName;
    var email=form.elements.email;
    var phone=form.elements.phone;
    if(!first||!last||!email||!phone)return;

    form.innerHTML=
      '<div class="mxp-profile-premium-form-head"><i>♙</i><div><strong>Informations personnelles</strong><p>Seuls votre prénom et votre nom sont modifiables ici.</p></div></div>'+
      '<div class="mxp-profile-premium-grid">'+
        '<label><span class="mxp-profile-premium-label">Prénom <em>*</em></span><div class="mxp-profile-premium-input"><i>♙</i></div></label>'+
        '<label><span class="mxp-profile-premium-label">Nom <em>*</em></span><div class="mxp-profile-premium-input"><i>♙</i></div></label>'+
        '<label class="wide"><span class="mxp-profile-premium-label">Adresse e-mail</span><div class="mxp-profile-premium-input is-readonly"><i>✉</i></div></label>'+
        '<label class="wide"><span class="mxp-profile-premium-label">Téléphone</span><div class="mxp-profile-premium-input is-readonly"><i>⌕</i></div></label>'+
      '</div>'+
      '<div class="mxp-profile-premium-actions">'+
        '<button class="mxp-profile-premium-save" type="submit" disabled><span>▣</span><b>Enregistrer prénom et nom</b></button>'+
        '<button class="mxp-profile-premium-cancel" type="button" disabled>Annuler</button>'+
        '<span data-mps-api-profile-message aria-live="polite"></span>'+
      '</div>'+
      '<div class="mxp-profile-premium-hint"><i>ⓘ</i><span>Les modifications seront enregistrées sur votre compte.</span></div>';

    var labels=form.querySelectorAll('.mxp-profile-premium-grid label');
    labels[0].querySelector('.mxp-profile-premium-input').appendChild(first);
    labels[1].querySelector('.mxp-profile-premium-input').appendChild(last);
    labels[2].querySelector('.mxp-profile-premium-input').appendChild(email);
    labels[3].querySelector('.mxp-profile-premium-input').appendChild(phone);

    first.required=true;
    last.required=true;
    email.readOnly=true;
    phone.readOnly=true;

    var save=form.querySelector('.mxp-profile-premium-save');
    var cancel=form.querySelector('.mxp-profile-premium-cancel');
    var msg=form.querySelector('[data-mps-api-profile-message]');
    var initialFirst=first.value||'';
    var initialLast=last.value||'';

    function syncDirty(){
      var dirty=first.value.trim()!==initialFirst.trim() || last.value.trim()!==initialLast.trim();
      save.disabled=!dirty;
      cancel.disabled=!dirty;
      if(dirty && msg && (msg.textContent||'').indexOf('Enregistré')!==-1)msg.textContent='';
    }

    first.addEventListener('input',syncDirty);
    last.addEventListener('input',syncDirty);

    cancel.addEventListener('click',function(){
      first.value=initialFirst;
      last.value=initialLast;
      if(msg)msg.textContent='';
      syncDirty();
    });

    form.addEventListener('submit',function(){
      if(!first.value.trim()||!last.value.trim())return;
      save.disabled=true;
      cancel.disabled=true;
      save.classList.remove('is-success');
      save.classList.add('is-saving');
      if(msg){msg.classList.remove('is-success','is-error','is-fading');msg.textContent='Enregistrement…';}
      var saveText=save.querySelector('b');
      if(saveText)saveText.textContent='Enregistrement…';
      var observer=new MutationObserver(function(){
        var text=(msg&&msg.textContent||'').trim();
        if(text.indexOf('Enregistr')!==-1){
          initialFirst=first.value||'';
          initialLast=last.value||'';
          save.classList.remove('is-saving');
          save.classList.add('is-success');
          if(saveText)saveText.textContent='✓ Modifications enregistrées';
          if(msg){msg.textContent='Tout est à jour';msg.classList.remove('is-error','is-fading');msg.classList.add('is-success');}
          syncDirty();
          setTimeout(function(){
            save.classList.remove('is-success');
            if(saveText)saveText.textContent='Enregistrer les modifications';
            if(msg){msg.classList.add('is-fading');setTimeout(function(){msg.textContent='';msg.classList.remove('is-success','is-fading');},220);}
          },1800);
          observer.disconnect();
        }else if(text && text!=='Enregistrement…'){
          save.classList.remove('is-saving','is-success');
          if(saveText)saveText.textContent='Enregistrer les modifications';
          if(msg){msg.classList.remove('is-success','is-fading');msg.classList.add('is-error');}
          syncDirty();
          observer.disconnect();
        }
      });
      if(msg)observer.observe(msg,{childList:true,subtree:true,characterData:true});
      setTimeout(function(){
        if(save.classList.contains('is-saving')){
          save.classList.remove('is-saving');
          if(saveText)saveText.textContent='Enregistrer les modifications';
          syncDirty();
        }
        observer.disconnect();
      },5000);
    });

    var renderObserver=new MutationObserver(function(){
      if(document.activeElement===first||document.activeElement===last)return;
      if(!save.disabled)return;
      initialFirst=first.value||'';
      initialLast=last.value||'';
    });
    renderObserver.observe(first,{attributes:true,attributeFilter:['value']});
    renderObserver.observe(last,{attributes:true,attributeFilter:['value']});
  }

  function boot(){
    addStyles();
    enhanceProfile();
    var portal=document.getElementById('MpsApiCustomerPortal');
    if(portal){
      new MutationObserver(function(){enhanceProfile()}).observe(portal,{childList:true,subtree:true});
    }
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else setTimeout(boot,0);
})();

;/* MXP_REPAIR_ACTION_CLIENT_ASSET_V1 */
(function(w,d){
'use strict';
if(w.__mxpRepairActionClientV1)return;w.__mxpRepairActionClientV1=true;
var SERVICE='https://maxpromo-messaging-v2-production.up.railway.app',support=[],customer=null,busy=false,timer=0,deepDone=false;
function esc(v){var x=d.createElement('div');x.textContent=v==null?'':String(v);return x.innerHTML}
function emailOf(c){return c&&c.emailAddress&&c.emailAddress.emailAddress||c&&c.email||''}
function cidOf(c){return String(c&&(c.id||c.customerId)||'')}
function requiredThread(x){if(!x||String(x.sourceType||'')!=='repair'||String(x.status||'').toLowerCase()==='resolved')return null;var sender=String(x.lastMessageSender||''),text=String(x.lastMessage||x.message||x.subject||'').trim();if(sender==='maxpromo'||Number(x.unreadCount||0)>0)return{kind:'required',text:text||'MAXPROMO attend votre réponse.',thread:x};if(sender==='customer')return{kind:'answered',text:text||'Votre réponse a bien été envoyée.',thread:x};return null}
function approvalLike(t){return /€|euro|devis|compl[eé]ment|suppl[eé]ment|accep|accord|payer|paiement|co[uû]t|tarif/i.test(String(t||''))}
function actionForRef(ref){var x=support.find(function(r){return String(r.sourceType||'')==='repair'&&String(r.sourceRef||'')===String(ref||'')});return requiredThread(x)}
function style(){
if(d.getElementById('mxp-repair-action-client-style'))return;
var s=d.createElement('style');s.id='mxp-repair-action-client-style';s.textContent=
'.mxp-action-pill{display:inline-flex!important;align-items:center!important;margin-top:5px!important;padding:3px 6px!important;border-radius:999px!important;background:#fff0b2!important;color:#725400!important;font-size:7px!important;font-weight:950!important;letter-spacing:.03em!important}'+
'.mxp-repair-action-client{margin:0 0 10px;padding:12px 13px;border:1px solid #efcb4c;border-radius:12px;background:linear-gradient(135deg,#fff8d5,#fffdf6);box-shadow:0 6px 16px rgba(95,74,0,.05)}'+
'.mxp-repair-action-client.is-answered{border-color:#b9d9c0;background:#f3faf5}.mxp-repair-action-client__top{display:flex;justify-content:space-between;gap:8px;align-items:center;margin-bottom:6px}.mxp-repair-action-client__top strong{font-size:11px;font-weight:950;color:#1a2230}.mxp-repair-action-client__top span{padding:4px 7px;border-radius:999px;background:#FFD31A;color:#111827;font-size:7px;font-weight:950;text-transform:uppercase}.mxp-repair-action-client.is-answered .mxp-repair-action-client__top span{background:#dff2e3;color:#14632b}.mxp-repair-action-client p{margin:0;color:#586273;font-size:9px;line-height:1.55;white-space:pre-line}.mxp-repair-action-client__actions{display:flex;gap:7px;flex-wrap:wrap;margin-top:10px}.mxp-repair-action-client__actions button{min-height:30px;padding:0 10px;border:1px solid #d9dde3;border-radius:8px;background:#fff;color:#273345;font-size:8px;font-weight:900;cursor:pointer}.mxp-repair-action-client__actions .is-main{background:#17191c;border-color:#17191c;color:#fff}.mxp-repair-action-client__actions .is-yes{background:#FFD31A;border-color:#d7b000;color:#111827}.mxp-repair-action-client__status{display:block;margin-top:7px;font-size:8px;font-weight:750;color:#6d7682}.mxp-dashboard-action-client{margin:0 0 14px;padding:14px 16px;border:1px solid #efcb4c;border-radius:14px;background:#fff9dc;display:flex;align-items:center;justify-content:space-between;gap:14px}.mxp-dashboard-action-client div{min-width:0}.mxp-dashboard-action-client strong{display:block;font-size:12px;color:#1a2230}.mxp-dashboard-action-client small{display:block;margin-top:4px;font-size:9px;color:#687385;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mxp-dashboard-action-client button{flex:0 0 auto;min-height:33px;padding:0 12px;border:0;border-radius:9px;background:#17191c;color:#fff;font-size:8px;font-weight:900;cursor:pointer}.mps-api-portal__nav [data-mxp-repair-action-count]:not(:empty){display:grid!important;place-items:center!important;min-width:18px!important;height:18px!important;padding:0 5px!important;border-radius:999px!important;background:#e5483f!important;color:#fff!important;font-size:8px!important;font-weight:950!important;margin-left:auto!important}@media(max-width:760px){.mxp-dashboard-action-client{align-items:flex-start;flex-direction:column}.mxp-repair-action-client__actions button{flex:1 1 auto}}';
d.head.appendChild(s)
}
function button(label,cls,ref,msg){var b=d.createElement('button');b.type='button';b.textContent=label;if(cls)b.className=cls;b.dataset.mxpActionRef=ref;if(msg)b.dataset.mxpActionQuick=msg;return b}
function makeBanner(ref,state){
var box=d.createElement('div');box.className='mxp-repair-action-client'+(state.kind==='answered'?' is-answered':'');box.dataset.mxpRepairActionClient=ref;
var top=d.createElement('div');top.className='mxp-repair-action-client__top';var strong=d.createElement('strong');strong.textContent=state.kind==='required'?'Action requise de votre part':'Réponse envoyée';var chip=d.createElement('span');chip.textContent=state.kind==='required'?'À traiter':'En attente de MAXPROMO';top.append(strong,chip);
var p=d.createElement('p');p.textContent=state.text;var actions=d.createElement('div');actions.className='mxp-repair-action-client__actions';
if(state.kind==='required'&&approvalLike(state.text)){actions.append(button('J’accepte','is-yes',state.thread.reference,'J’accepte le complément proposé.'),button('Je refuse','',state.thread.reference,'Je refuse le complément proposé.'))}
actions.append(button(state.kind==='required'?'Répondre à MAXPROMO':'Voir la conversation','is-main',state.thread.reference,''));
var st=d.createElement('small');st.className='mxp-repair-action-client__status';box.append(top,p,actions,st);return box
}
function ensureNavBadge(){
var nav=d.querySelector('[data-mps-api-nav="repairs"]');if(!nav)return null;var b=nav.querySelector('[data-mxp-repair-action-count]');if(b)b.remove();return null
}
function refsRequired(){return support.map(requiredThread).filter(function(x){return x&&x.kind==='required'})}
function decorateRepairRows(){
var rows=d.querySelectorAll('[data-mxp-repair-rows] .mxp-flow-item');
rows.forEach(function(row){
support.forEach(function(t){if(String(t.sourceType||'')!=='repair'||!row.textContent.includes(String(t.sourceRef||'')))return;var state=requiredThread(t);if(!state)return;
var old=row.querySelector('[data-mxp-repair-action-client]');if(old)old.remove();row.insertBefore(makeBanner(t.sourceRef,state),row.firstChild);
var cell=row.querySelector('.mxp-device-cell>div:last-child');if(cell&&state.kind==='required'&&!cell.querySelector('.mxp-action-pill')){var pill=d.createElement('span');pill.className='mxp-action-pill';pill.textContent='ACTION REQUISE';cell.appendChild(pill)}
})})
}
function decorateDetail(){
var modal=d.querySelector('[data-mxp-detail-modal]'),body=d.querySelector('[data-mxp-detail-body]');if(!modal||modal.hidden||!body)return;
support.forEach(function(t){if(String(t.sourceType||'')!=='repair'||!body.textContent.includes(String(t.sourceRef||'')))return;var state=requiredThread(t);if(!state)return;var old=body.querySelector('[data-mxp-repair-action-client]');if(old)old.remove();body.insertBefore(makeBanner(t.sourceRef,state),body.firstChild)})
}
function decorateDashboard(){
var panel=d.querySelector('[data-mps-api-panel="overview"]');if(!panel)return;var old=panel.querySelector('[data-mxp-dashboard-action-client]');if(old)old.remove();
var req=support.map(function(t){return{t:t,s:requiredThread(t)}}).filter(function(x){return x.s&&x.s.kind==='required'});if(!req.length)return;
var x=req[0],host=panel.querySelector('.mxp-dashboard-top')||panel.firstElementChild,box=d.createElement('div');box.className='mxp-dashboard-action-client';box.dataset.mxpDashboardActionClient='1';var left=d.createElement('div'),strong=d.createElement('strong'),small=d.createElement('small');strong.textContent='Votre réponse est nécessaire'+(req.length>1?' · '+req.length+' réparations':'');small.textContent=String(x.t.device||'Réparation')+' · '+String(x.t.sourceRef||'')+' — '+String(x.s.text||'');left.append(strong,small);var b=button('Répondre maintenant','is-main',x.t.reference,'');box.append(left,b);if(host&&host.parentNode)host.parentNode.insertBefore(box,host)
}
function decorate(){
style();var badge=ensureNavBadge(),n=refsRequired().length;if(badge)badge.textContent=n?String(n):'';decorateRepairRows();decorateDetail();decorateDashboard()
}
async function loadSupport(){
if(busy)return;var api=w.MaxpromoCustomerAPI;if(!api||!api.hasSession||!api.hasSession())return;busy=true;
try{customer=await api.getCustomer();var cid=cidOf(customer),email=emailOf(customer);if(!cid||!email)return;var u=SERVICE+'/customer/support?customerId='+encodeURIComponent(cid)+'&email='+encodeURIComponent(email),r=await fetch(u,{cache:'no-store'}),j=await r.json().catch(function(){return{}});if(r.ok&&j.success&&Array.isArray(j.requests))support=j.requests;decorate();applyDeepLink()}catch(e){console.error('[MXP_REPAIR_ACTION_CLIENT]',e)}finally{busy=false}
}
function clickMessage(ref){
var nav=d.querySelector('[data-mps-api-nav="messages"]');if(nav)nav.click();var tries=0,iv=setInterval(function(){var b=[].slice.call(d.querySelectorAll('[data-mxp-message-open]')).find(function(x){return String(x.dataset.mxpMessageOpen)===String(ref)});if(b){clearInterval(iv);b.click()}else if(++tries>20)clearInterval(iv)},100)
}
function clickRepair(ref){
var nav=d.querySelector('[data-mps-api-nav="repairs"]');if(nav)nav.click();var tries=0,iv=setInterval(function(){var rows=[].slice.call(d.querySelectorAll('[data-mxp-repair-rows] .mxp-flow-item')),row=rows.find(function(x){return x.textContent.includes(String(ref))});var b=row&&row.querySelector('[data-mxp-detail="repair"]');if(b){clearInterval(iv);b.click()}else if(++tries>20)clearInterval(iv)},100)
}
function cleanDeep(){try{var u=new URL(location.href);['mps_account','mxp_panel','mxp_ref','mxp_repair'].forEach(function(k){u.searchParams.delete(k)});history.replaceState({},'',u.pathname+(u.searchParams.toString()?'?'+u.searchParams.toString():'')+u.hash)}catch(e){}}
function applyDeepLink(){
if(deepDone)return;var p=new URLSearchParams(location.search),panel=p.get('mxp_panel')||'',ref=p.get('mxp_ref')||'',repair=p.get('mxp_repair')||'';if(!panel&&!ref&&!repair)return;
var portal=d.getElementById('MpsApiCustomerPortal');if(!portal||portal.hidden)return;
if(panel==='messages'&&ref){if(!support.some(function(x){return String(x.reference)===String(ref)}))return;deepDone=true;clickMessage(ref);cleanDeep();return}
if(panel==='repairs'||repair){deepDone=true;clickRepair(repair);cleanDeep();return}
}
async function quickReply(ref,msg,source){
if(!customer)customer=await w.MaxpromoCustomerAPI.getCustomer();var fd=new FormData();fd.append('customerId',cidOf(customer));fd.append('email',emailOf(customer));fd.append('message',msg);var r=await fetch(SERVICE+'/customer/support/'+encodeURIComponent(ref)+'/messages',{method:'POST',body:fd}),j=await r.json().catch(function(){return{}});if(!r.ok||!j.success)throw new Error(j.error||'send');var st=source&&source.closest('[data-mxp-repair-action-client]')&&source.closest('[data-mxp-repair-action-client]').querySelector('.mxp-repair-action-client__status');if(st)st.textContent='Réponse envoyée ✓';await new Promise(function(ok){setTimeout(ok,250)});await loadSupport();clickMessage(ref)
}
d.addEventListener('click',function(e){var b=e.target.closest('[data-mxp-action-ref]');if(!b)return;e.preventDefault();var ref=b.dataset.mxpActionRef||'',msg=b.dataset.mxpActionQuick||'';if(msg){var card=b.closest('[data-mxp-repair-action-client]'),st=card&&card.querySelector('.mxp-repair-action-client__status');if(st)st.textContent='Envoi de votre réponse…';card&&card.querySelectorAll('button').forEach(function(x){x.disabled=true});quickReply(ref,msg,b).catch(function(){if(st)st.textContent='Impossible d’envoyer la réponse. Réessayez.';card&&card.querySelectorAll('button').forEach(function(x){x.disabled=false})})}else clickMessage(ref)},true);
function boot(){
style();var api=w.MaxpromoCustomerAPI,p=new URLSearchParams(location.search);
if(p.get('mps_account')==='1'&&api&&api.hasSession&&!api.hasSession()){return}
loadSupport();var portal=d.getElementById('MpsApiCustomerPortal');if(portal){var mo=new MutationObserver(function(){clearTimeout(timer);timer=setTimeout(function(){decorate();if(!portal.hidden)loadSupport()},80)});mo.observe(portal,{subtree:true,childList:true,attributes:true,attributeFilter:['hidden']})}
setInterval(function(){var p=d.getElementById('MpsApiCustomerPortal');if(p&&!p.hidden)loadSupport()},30000)
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){setTimeout(boot,80)});else setTimeout(boot,80)
})(window,document);

/* MXP_REPAIR_FLOW_CLIENT_V3 */
(function(w,d){
  if(w.__mxpRepairFlowClientV3)return;
  w.__mxpRepairFlowClientV3=true;
  var API='https://reprise-secure-production.up.railway.app';
  var LABELS=['Demande de réparation','Envoi de votre appareil','Appareil reçu chez MAXPROMO','Réparation en cours','Réparation terminée','Appareil renvoyé','Appareil livré'];
  var STATUS=['Demande de réparation','Envoi de votre appareil','Appareil reçu chez MAXPROMO','Réparation en cours','Réparation terminée','Appareil renvoyé','Appareil livré'];
  var cache=[],customer=null,busy=false,lastFetch=0,timer=0;
  function digits(v){return String(v||'').replace(/\D+/g,'')}
  function json(v){if(!v)return{};if(typeof v==='object')return v;try{return JSON.parse(v)||{}}catch(e){return{}}}
  function portal(){return d.getElementById('MpsApiCustomerPortal')}
  function siteFor(ref){var n=digits(ref);if(!n)return null;return cache.find(function(r){return String(r.order_numeric_id||'')===n||digits(r.order_name)===n})||null}
  function stageFor(site){
    if(!site)return null;
    var inbound=json(site.repair_inbound_tracking),outbound=json(site.repair_outbound_tracking);
    var ins=String(inbound.status||'').toLowerCase(),outs=String(outbound.status||'').toLowerCase(),fv=String(site.fulfillment_status||'').toUpperCase();
    var stage=0;
    if(inbound.shipmentReference||inbound.number||inbound.labelUrl||['label_ready','label_processing','registered','in_transit','out_for_delivery','available_for_pickup','ready_for_pickup','delivered'].indexOf(ins)>=0)stage=1;
    if(site.repair_received_at||ins==='delivered')stage=2;
    if(stage>=2&&(fv.indexOf('IN_PROGRESS')>=0||fv.indexOf('PARTIALLY')>=0))stage=3;
    if(site.repair_completed_at)stage=4;
    if(['in_transit','out_for_delivery','available_for_pickup','ready_for_pickup'].indexOf(outs)>=0)stage=5;
    if(outs==='delivered')stage=6;
    return stage;
  }
  function refFor(flow,p){
    var item=flow.closest('.mxp-flow-item');
    if(item){var vals=item.querySelectorAll('.mxp-table-value');if(vals[0])return vals[0].textContent||''}
    var body=flow.closest('[data-mxp-detail-body]')||p;
    var small=body&&body.querySelector('.mxp-rd-device small');
    return small?small.textContent||'':'';
  }
  function setStage(flow,stage){
    var steps=flow.querySelectorAll('.mxp-live-flow__step');
    if(steps.length!==7)return;
    var head=flow.querySelector('.mxp-live-flow__head strong');if(head)head.textContent='Étapes de votre réparation';
    steps.forEach(function(step,i){
      var span=step.querySelector('span');if(span)span.textContent=LABELS[i];
      if(stage===null)return;
      step.classList.toggle('is-done',i<stage||(stage===6&&i===6));
      step.classList.toggle('is-current',i===stage&&stage<6);
    });
  }
  function setStatus(flow,stage,p){
    if(stage===null)return;
    var item=flow.closest('.mxp-flow-item');
    if(item){var chip=item.querySelector('.mxp-chip');if(chip)chip.textContent=STATUS[stage]}
    var detail=flow.closest('[data-mxp-detail-body]');
    if(detail){var chip2=detail.querySelector('.mxp-rd-head__right .mxp-chip');if(chip2)chip2.textContent=STATUS[stage]}
  }
  function decorate(){
    var p=portal();if(!p)return;
    p.querySelectorAll('[data-mps-api-panel="repairs"] .mxp-live-flow,[data-mxp-detail-body] .mxp-live-flow').forEach(function(flow){
      var steps=flow.querySelectorAll('.mxp-live-flow__step');if(steps.length!==7)return;
      var site=siteFor(refFor(flow,p)),stage=stageFor(site);
      setStage(flow,stage);setStatus(flow,stage,p);
    });
  }
  function emailOf(c){return String(c&&c.emailAddress&&c.emailAddress.emailAddress||c&&c.email||'').trim().toLowerCase()}
  async function refresh(force){
    var p=portal(),api=w.MaxpromoCustomerAPI;if(!p||p.hidden||!api||!api.hasSession||!api.hasSession()||!api.getCustomer)return;
    var now=Date.now();if(!force&&cache.length&&now-lastFetch<2500){decorate();return}
    if(busy)return;busy=true;
    try{
      if(!customer)customer=await api.getCustomer();
      var cid=String(customer&&customer.id||customer&&customer.customerId||''),email=emailOf(customer);if(!cid||!email)return;
      var res=await fetch(API+'/customer/orders?customerId='+encodeURIComponent(cid)+'&email='+encodeURIComponent(email),{cache:'no-store'}),data=await res.json().catch(function(){return{}});
      if(res.ok&&data&&data.success&&Array.isArray(data.orders)){cache=data.orders;lastFetch=Date.now()}
      decorate();
    }catch(e){console.error('[MXP_REPAIR_FLOW_CLIENT_V3]',e)}finally{busy=false}
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(function(){decorate();refresh(false)},100)}
  function boot(){
    var p=portal();if(!p)return;
    decorate();refresh(true);
    new MutationObserver(schedule).observe(p,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
    p.addEventListener('click',function(){setTimeout(function(){decorate();refresh(false)},60)},true);
    setInterval(function(){if(!p.hidden)refresh(true)},30000);
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){setTimeout(boot,100)},{once:true});else setTimeout(boot,100);
})(window,document);

(function(w){
  if(w.__mxpSignupProfileSyncV1)return;
  w.__mxpSignupProfileSyncV1=true;
  var KEY='mxp_signup_pending_v1';
  function getPending(){try{var raw=sessionStorage.getItem(KEY);return raw?JSON.parse(raw):null}catch(e){return null}}
  function clearPending(){try{sessionStorage.removeItem(KEY)}catch(e){}}
  function emailOf(c){return String(c&&c.emailAddress&&c.emailAddress.emailAddress||c&&c.email||'').trim().toLowerCase()}
  async function apply(){
    var pending=getPending();
    if(!pending||!pending.email||!pending.firstName||!pending.lastName)return false;
    if(pending.createdAt&&Date.now()-Number(pending.createdAt)>1800000){clearPending();return false}
    var api=w.MaxpromoCustomerAPI;
    if(!api||!api.hasSession||!api.hasSession()||!api.getCustomer||!api.updateName)return false;
    try{
      var c=await api.getCustomer();
      if(emailOf(c)!==String(pending.email).trim().toLowerCase()){clearPending();return false}
      var first=String(c&&c.firstName||'').trim(),last=String(c&&c.lastName||'').trim();
      if(!first||!last)await api.updateName(pending.firstName,pending.lastName);
      if(!api.sendWelcomeEmail)throw new Error('Mail de bienvenue indisponible.');
      await api.sendWelcomeEmail();
      clearPending();
      try{sessionStorage.setItem('mxp_signup_completed_v1','1')}catch(e){}
      w.dispatchEvent(new CustomEvent('mxp:signup-profile-synced'));
      return true;
    }catch(e){return false}
  }
  [250,700,1500,3000].forEach(function(ms){setTimeout(apply,ms)});
  w.addEventListener('mps:customer-authenticated',function(){setTimeout(apply,120)});
  w.addEventListener('pageshow',function(){setTimeout(apply,160)});
})(window);


/* MXP_CLOSE_GLASS_V2 */
(function(){
  if(window.__mxpCloseGlassV2)return;
  window.__mxpCloseGlassV2=true;
  function install(){
    var old=document.getElementById('mxp-close-glass-v1-style');
    if(old)old.remove();
    if(document.getElementById('mxp-close-glass-v2-style'))return;
    var style=document.createElement('style');
    style.id='mxp-close-glass-v2-style';
    style.textContent=
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close{width:auto!important;min-width:80px!important;height:35px!important;padding:0 12px!important;border:1px solid rgba(191,155,48,.13)!important;border-radius:999px!important;background:linear-gradient(135deg,rgba(255,255,255,.16),rgba(255,255,255,.07))!important;color:rgba(22,28,38,.72)!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:7px!important;font-size:0!important;-webkit-backdrop-filter:blur(30px) saturate(180%)!important;backdrop-filter:blur(30px) saturate(180%)!important;box-shadow:0 10px 34px rgba(15,23,42,.025),inset 0 1px 0 rgba(255,255,255,.48)!important;transition:background .2s ease,border-color .2s ease,box-shadow .2s ease,transform .2s ease,color .2s ease!important}' +
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close span{font-size:15px!important;line-height:1!important;font-weight:400!important;opacity:.62!important}' +
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close b{font-size:9px!important;line-height:1!important;font-weight:760!important;letter-spacing:.018em!important;opacity:.76!important}' +
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close:hover{border-color:rgba(191,155,48,.22)!important;background:linear-gradient(135deg,rgba(255,255,255,.30),rgba(255,255,255,.14))!important;color:rgba(22,28,38,.86)!important;box-shadow:0 12px 36px rgba(15,23,42,.045),inset 0 1px 0 rgba(255,255,255,.64)!important;transform:translateY(-1px)!important}' +
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close:active{background:rgba(255,255,255,.18)!important;transform:translateY(0)!important;box-shadow:0 6px 22px rgba(15,23,42,.03),inset 0 1px 0 rgba(255,255,255,.52)!important}' +
      '#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close:focus-visible{outline:2px solid rgba(191,155,48,.32)!important;outline-offset:3px!important}' +
      '@media(max-width:850px){#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close{min-width:35px!important;width:35px!important;height:35px!important;padding:0!important;gap:0!important}#MpsApiCustomerPortal .mps-api-portal__main .mps-api-portal__close b{display:none!important}}';
    document.head.appendChild(style);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',install,{once:true});else install();
})();